
export default {
    name: 'ChatMessage',
    props: {
        message: {
            type: Object,
            default: null,
            required: false
        },
        skeleton: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        isNotArabic () {
            return !/^[\u0621-\u064A0-9 ]+$/.test(this.message.message.replace(/<[^>]*>/g, '').trim().charAt(0))
        }
    }
}
